// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton-closeButton-rSa","iconContainer":"CloseButton-iconContainer-kdz"};